import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    salaryDeductionList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    salaryDeductionDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const salaryDeductionSlice = createSlice({
  name: 'salaryDeduction',
  initialState,
  reducers: {
    getSalaryDeductionList: (state, action) => {
        state.salaryDeductionList.requesting = true;
        state.salaryDeductionList.error = null;
        state.salaryDeductionList.items = [];
        state.salaryDeductionList.success = false;
        state.salaryDeductionList.filters = action.payload;
    },
    getSalaryDeductionListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.salaryDeductionList.requesting = false;        
        state.salaryDeductionList.items = data;
        state.salaryDeductionList.success = true; 
        state.salaryDeductionList.pagination.current_page = current_page;
        state.salaryDeductionList.pagination.per_page = per_page;
        state.salaryDeductionList.pagination.total = total;
    },
    getSalaryDeductionListFail: (state, action) => {        
        state.salaryDeductionList.requesting = false;
        state.salaryDeductionList.error = action.payload;
    },
    getSalaryDeductionDetails: (state) => {
        state.salaryDeductionDetails.requesting = true;
        state.salaryDeductionDetails.error = null;
        state.salaryDeductionDetails.data = null;
        state.salaryDeductionDetails.success = false; 
    },
    getSalaryDeductionDetailsSuccess: (state, action) => {
        state.salaryDeductionDetails.requesting = false;
        state.salaryDeductionDetails.data = action.payload;
        state.salaryDeductionDetails.success = true; 
    },
    getSalaryDeductionDetailsFail: (state, action) => {        
        state.salaryDeductionDetails.requesting = false;
        state.salaryDeductionDetails.error = action.payload;
    },
    doSalaryDeductionCreate: (state) => {
        state.salaryDeductionDetails.requesting = true;
        state.salaryDeductionDetails.error = null;
        state.salaryDeductionDetails.data = null;
        state.salaryDeductionDetails.success = false; 
    },
    doSalaryDeductionUpdate: (state) => {
        state.salaryDeductionDetails.requesting = true;
        state.salaryDeductionDetails.error = null;
        state.salaryDeductionDetails.data = null;
        state.salaryDeductionDetails.success = false; 
    },
    doSalaryDeductionDelete: (state) => {
        state.salaryDeductionDetails.requesting = true;
        state.salaryDeductionDetails.error = null;
        state.salaryDeductionDetails.data = null;
        state.salaryDeductionDetails.success = false; 
    },
  },
})

export const { 
    getSalaryDeductionList, getSalaryDeductionListSuccess, getSalaryDeductionListFail,
    getSalaryDeductionDetails, getSalaryDeductionDetailsSuccess, getSalaryDeductionDetailsFail,
    doSalaryDeductionCreate, doSalaryDeductionUpdate, doSalaryDeductionDelete
} = salaryDeductionSlice.actions

export default salaryDeductionSlice.reducer